import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography } from '@mui/material';
import { ResultsPaper, ConfirmButton, AppCharacter, Text } from './useStyles';
import alertDisclaimer from '../assets/images/alert_disclaimer.svg';

const Disclaimer = ({ onNext }) => {
    const { t } = useTranslation();

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                height: '100%',
                width: '100%',
                bottom: 0,
                textAlign: 'center',
                backgroundColor: '#FFCC00',
                padding: '0 15px',
                boxSizing: 'border-box',
                borderRadius: '20px 20px 0 0',
                margin: '15px 0 0 0'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '20px' }}>
                <img
                    src={alertDisclaimer}
                    alt="Warning"
                    style={{ maxHeight: '4vh', margin: 0 }}
                />
                <Typography variant="h5" gutterBottom>
                    {t('disclaimer_title')}
                </Typography>
            </div>
            <AppCharacter>
                <img
                    src='/drita_14.png'
                    alt="Isabel"
                    style={{ maxHeight: '24vh' }}
                />
            </AppCharacter>
            <ResultsPaper sx={{ height: '80%', padding: '20px', marginTop: '0px' }}>
                <Text>
                    {t('disclaimer_text')}
                </Text>
                <ConfirmButton onClick={onNext}>
                    {t('accept_disclaimer')}
                </ConfirmButton>
            </ResultsPaper>
        </Container>
    );
};

export default Disclaimer;